export const environment = {
  ENV: 'dit',
  APP: 'sol-catalog',
  KEYCLOAK_REALM: 'asm',
  KEYCLOAK_URL: 'https://asm-auth.ditext.outpost24.com/auth',
  KEYCLOAK_CLIENT_ID: 'sol-catalog',
  ASM_PLATFORM_NG_URL: 'https://asm-platform-ng.ditext.outpost24.com',
};
